import { fetchData } from "@request";

type BankRegexp = {
  description: string;
  id: string;
  method: string;
  regex: string;
  type: string;
};

type Bank = {
  alias: string;
  bank_id_code: string;
  id: string;
  logo: string;
  name: string;
  phone_number: string;
  push_notification_packages: string[];
  regexes: BankRegexp[];
  region: {
    id: number;
  };
  require_account_for_sbp: boolean;
  uniq_only: boolean;
};

export const getBanks = async () => {
  try {
    const response = await fetchData<Bank[]>({
      url: `api/v1/banks`,
    });

    return response;
  } catch (error) {
    console.error("Banks failed:", error);
    throw error;
  }
};
